import React from 'react'
import PropTypes from 'prop-types'

import wrapWithCustomerSelection from 'customer/CustomerSelectionWrapper'

class BillCustomerSelector extends React.Component {

  static propTypes = {
    customerId: PropTypes.string,
    contactId: PropTypes.string,
    customer: PropTypes.object,
    onCustomerSelectionChanged: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.customerId !== nextProps.customerId
      || this.props.contactId !== nextProps.contactId) {
      this.props.onCustomerSelectionChanged(nextProps)
    }
  }

  render() {
    return null
  }

}

export default wrapWithCustomerSelection(BillCustomerSelector, {
  showLabel: true,
  customerLabel: 'Add Customer',
  contactLabel: 'Add Contact'
})



// WEBPACK FOOTER //
// ./src/billing/common/modules/header/BillCustomerSelector.js